import { OrderCommentActionModal } from '../OrderCommentActionModal/OrderCommentActionModal';

export interface ApproveExecutorModalProps {
    visible: boolean;
    onHide: () => void;
    orderId: string;
}

/** Показывает подтверждение исполнителя заказа администратором. */
export const ApproveExecutorModal = (props: ApproveExecutorModalProps) => (
    <OrderCommentActionModal
        {...props}
        action="approveExecutor"
    />
);
